import { AttendanceInProgress, AttendanceProcessFailureType } from '../../../../../../db/classes/types';

export function getLatestFailure(attendanceInProgress: AttendanceInProgress | null | undefined) {
  if (!attendanceInProgress) return;

  const { failures } = attendanceInProgress;

  const unresponsiveAttendeesFailures = failures.filter(
    (failure) => failure.type === AttendanceProcessFailureType.UNRESPONSIVE_ATTENDEES_FAILURE
  );

  /**
   * failures.length - 1 because we select latest failure
   * while we store the data in failures array we push latest failure in array at the end
   */
  const latestFailure = unresponsiveAttendeesFailures[unresponsiveAttendeesFailures.length - 1];
  return latestFailure;
}
